import React from "react";
import {ListItem, SectionHeading} from "../PromotionsText";

const ExcludedPlayersSection = () => (
  <>
    <SectionHeading>Excluded and Disqualified Players</SectionHeading>

    <ListItem marker="(a)">
      {"The following persons shall be excluded/disqualified from participating in any Promotions: (1) any person prohibited from gaming within the State where Evenplay is permitted to offer Services, (2) an employee of a supplier or vendor of Evenplay (unless otherwise expressly agreed to in writing by Evenplay after notice from such supplier or vendor); (3) any individual prohibited from participating or using the Services under any Rules (including, without limitation, the General Terms); and (4) any employee of any company or entity who has administrative or privileged access to Evenplay’s online gaming data or systems (collectively, “Unauthorized Persons”)."}
    </ListItem>

    <ListItem marker="(b)" withBottomMargin>
      {"If You have received communication from Us that you are not eligible for participating in any of Our Promotions, then You would be ineligible to participate in any such Promotions or bonus privileges."}
    </ListItem>
  </>
);

export default ExcludedPlayersSection;
